/* @flow */
import cx from 'classnames';
import React, { PropTypes } from 'react';

import Group from 'entities/Group';
import Organization from 'entities/Organization';
import Image from 'components/Image.jsx';

import styles from './styles/GroupAvatar.css';

class GroupAvatar extends React.Component {
  static propTypes = {
    group: React.PropTypes.oneOfType([
      React.PropTypes.instanceOf(Group),
      React.PropTypes.instanceOf(Organization),
    ]).isRequired,
    size: PropTypes.oneOf([
      'xxsmall',
      'xsmall',
      'small',
      'medium',
      'large',
    ]),
  };

  render() {
    return (
      <Image
        {...this.props}
        className={cx(styles[this.props.size], this.props.className)}
        src={this.props.group.getAvatarUrl()}
        circle
      />
    );
  }
}

export default GroupAvatar;



// WEBPACK FOOTER //
// ./src/groups/components/GroupAvatar.jsx